import React from 'react';
import PT from 'prop-types';
import cIf from 'classnames';
import { replace, includes, map, filter } from 'lodash';
import { ResponsivenessGrid } from '../toolkit';
import TranslatorManager from 'ts-translate-js';

const tr = TranslatorManager.boundTR;

let sectionComponentFromType = {
    banner: ProductBanner,
    text: ProductTextSection,
    youtubevideo: ProductVideo
};

export function OtherProductSections({ sections, typeOfSectionEnum, integ }) {
    const otherSections = filter(sections, function(section) {
        return section.type != typeOfSectionEnum.banner;
    });
    const otherGenSections = map(otherSections, (section, index) => {
        return <Section key={"section_" + index} {...section} />;
    });

    let content = null;
    if(otherGenSections.length > 1) 
        content = <ResponsivenessGrid items={otherGenSections}
                                   nbrColumnsByBreakpointConfigs={{ mobile: 1, tablet: 1, small: 2, large: 2 }} />;
    else
        content = otherGenSections;
        
    return (
        <div className={integ}>
            {otherGenSections.length > 0 ?
             <div key="productSections" className="row-content-with-padding product-section-container">
                 {content}
             </div> : null}
        </div>
    );
}
OtherProductSections.propTypes = {
    sections: PT.array,
    typeOfSectionEnum: PT.object,
    integ: PT.string
};

export function Section(props) {
    let Component = sectionComponentFromType[props.type];

    return (
        <Component {...props} />
    );
}
Section.propTypes = {
    type: PT.string,
    restBaseUrl: PT.string
};

export function shouldDisplayItemInBanner(items, itemToDisplay) {
    return includes(items, itemToDisplay);
}

export function ProductBanner(props) {
    let hasSubtitle = props.subtitle != undefined && props.subtitle !== "";

    let bannerTextClass = hasSubtitle ? "event-banner-with-more-text" : "event-banner-text";
    let subtitle = hasSubtitle ? <h2>{props.subtitle}</h2> : null;

    return (
        <div className="buyTicketEventInfo">
            <div className={cIf(["row-content-with-padding event-banner", props.align])} style={{ "backgroundImage": `url(${props.bannerPath})` }}>
                <div className={cIf([bannerTextClass, props.contentColor])}>
                    {
                        shouldDisplayItemInBanner(props.itemsInBanner, "representationType") ? 
                        <h4>{props.representationType}</h4>
                        : null
                    }
                    {
                        shouldDisplayItemInBanner(props.itemsInBanner, "title") ? (
                            <div>
                                <h1>{props.title}</h1>
                                {subtitle}
                            </div>
                        )
                        : null
                    }
                    {
                        shouldDisplayItemInBanner(props.itemsInBanner, "dates") ?
                        <p className="event-dates">{props.readableDates}</p>
                        : null
                    }
                    {
                        shouldDisplayItemInBanner(props.itemsInBanner, "physicalVenue") ? (
                            <p className="event-location">
                                {props.physicalVenueName}<br />
                            {props.venueAddress}
                            </p>
                        )
                        : null
                    }
                </div>
            </div>
            <div className="event-banner-bottom-text">
                {
                    shouldDisplayItemInBanner(props.itemsInBanner, "title") ? (
                        <div>
                            <h1>{props.title}</h1>
                            {subtitle}
                        </div>
                    )
                    : null
                }
                {
                    shouldDisplayItemInBanner(props.itemsInBanner, "dates") ?
                    <p className="event-dates">{props.readableDates}</p>
                    : null
                }
                {
                    shouldDisplayItemInBanner(props.itemsInBanner, "physicalVenue") ? (
                        <p className="event-location">
                            {props.physicalVenueName}<br />
                        {props.venueAddress}
                        </p>
                    )
                    : null
                }
            </div>
        </div>
    );
}
ProductBanner.propTypes = {
    bannerPath: PT.string,
    align: PT.string,
    contentColor: PT.string,
    title: PT.string,
    subtitle: PT.string,
    readableDates: PT.string,
    representationType: PT.string,
    physicalVenueName: PT.string,
    venueAddress: PT.string,
    itemsInBanner: PT.array
};

export function ProductTextSection(props) {
    return (
        <div>
            <h2>{props.title ? props.title : tr("Description")}</h2>
            <div className="smaller-spacer-row" />
            <div dangerouslySetInnerHTML={{ __html: props.content }} ></div>
        </div>
    );
}
ProductTextSection.propTypes = {
    subtype: PT.string,
    content: PT.string,
    title: PT.string,
    tr: PT.func
};

const containerByType = {
    "youtubevideo": YoutubeVideo
};

export function ProductVideo(props) {
    let Container = containerByType[props.type];
    
    return (
        <div className="event-video-container">
            <h2>{props.title ? props.title : tr("Vidéo promotionnelle")}</h2>
            <div className="smaller-spacer-row" />
            <div className="event-video-frame">
                <div className="event-video">
                    <Container link={props.link} />
                </div>
            </div>
        </div>
);
}
ProductVideo.propTypes = {
    type: PT.string,
    title: PT.string,
    link: PT.string,
    tr: PT.func
};

export function YoutubeVideo(props) {
    const videoUrl = replace(props.link, "watch?v=", "embed/"); /* eslint-disable-line security/detect-non-literal-fs-filename */

    return (
        <iframe
            title="Event promotion video"
            src={videoUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen>
        </iframe>
    );
}
YoutubeVideo.propTypes = {
    link: PT.string
};


//TODO: Re-activate this when promotions will be supported
// export function ProductPromotions(props) {
//     let tr = props.tr;
//     let promoLinks = map(props.promotions.links, (link, index) => {
//         return (
//             <div key={"promoLink-" + index} className="promo-link"><i className="material-icons md-18">local_offer</i><a href="#">{link}</a><br /></div>
//         );
//     });

//     return (
//         <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-3">
//             <div className="event-promo-box mdc-card">
//                 <div className="header-footer-separator" />
//                 <div className="promo-content">
//                     <h4>{tr("Promotions")}</h4>
//                     {props.promotions.description}.<br />
//                     {promoLinks}
//                 </div>
//             </div>
//         </div>
//     );
// }
// EventPromotions.propTypes = {
//     tr: PT.func,
//     promotions: PT.object
// };

